export const SENTINEL_API_BASE =
  process.env.REACT_APP_PARSE_PDF_API_URL || "https://app.sentinelzone.com:8443";
